import { Injectable } from '@angular/core';

import { Task } from '../shared/model';
import { TaskProcessContext } from '../shared/task-process-context.class';
import { PublicContextAndTaskActionsComponent } from './public-context-and-task-actions.component';
import { TaskProcessModalsService } from '../shared/task-process-modals.service';

@Injectable({
  providedIn: 'root',
})
export class PublicContextAndTaskActionsService {
  constructor(private taskProcessModalsService: TaskProcessModalsService) {}

  showPublicContextAndTaskActionsLog(
    taskProcessContext: TaskProcessContext,
    task: Task,
    shouldSelectPublicContextTab: boolean
  ) {
    const hasPublicContext = !task.isPrivate;
    const modalInput = {
      task,
      taskProcessContext,
      hasPublicContext,
      shouldSelectPublicContextTab,
    };
    this.taskProcessModalsService.showTaskProcessPageModal(PublicContextAndTaskActionsComponent, modalInput);
  }
}
